import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import { useTimeZoneContext } from "../../../lib/context/TimeZone/TimeZoneContext";
import { useAuthContext } from "../../../lib/context/Auth/AuthContext";
import { useAccountRequests } from "../../../api/grpc/account/useAccountRequests";

import { Icon } from "../../../components/shared/Icon/Icon";
import { Button } from "../../../components/shared/Button/Button";

import "./MFAReminderModal.scss";

export const MfaReminderModal = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { user, updateUser } = useAuthContext();
  const { updateAccount } = useAccountRequests();
  const { timeZone } = useTimeZoneContext();

  const handleUpdateAccount = async () => {
    if (!user) return;

    try {
      setLoading(true);
      await updateAccount(
        {
          displayName: user.displayName,
          email: user.email.toLowerCase(),
          firstName: user.firstName,
          lastName: user.lastName,
          newPassword: "",
          phoneNumber: "",
          photoUrl: user.picture,
          googleAccountConnected: user.googleAccountConnected,
          o365AccountConnected: user.o365AccountConnected,
          googleAccountLinkedEmail: user.googleAccountLinkedEmail,
          o365AccountLinkedEmail: user.o365AccountLinkedEmail,
          timeZone,
          mfaType: user.mfaType,
          recoveryEmail: user?.recoveryEmail || "",
          show2FaReminder: false,
        },
        ["show2FaReminder"]
      );

      updateUser({ show2FaReminder: false });
    } catch (error: any) {
      toast.error(error?.message || "Failed to update account");
    } finally {
      setLoading(false);
    }
  };

  const handleActivate2FA = async () => {
    await handleUpdateAccount();
    history.push("/account");
  };

  const handleContinueWithout2FA = async () => {
    await handleUpdateAccount();
  };

  return (
    <Modal isOpen className="MFAReminderModal">
      <ModalHeader>
        <Icon icon="logo" />
        <h4>Activate 2-factor authentication (2FA)</h4>
      </ModalHeader>
      <ModalBody>
        <div className="MFAReminderModal__key">
          <Icon icon="2fa-key-icon" />
        </div>
        <span>
          By setting up 2FA, you add an extra layer of security to your Goget
          Owner/Admin account sign-in. For example, you first enter your
          password and, when prompted, you also type a dynamically generated
          verification code provided by an authenticator app.
        </span>
      </ModalBody>
      <ModalFooter>
        <Button
          title="Activate 2FA"
          color="business"
          size="large"
          className="modal-footer__button"
          onClick={handleActivate2FA}
          disabled={loading}
        />
        <Button
          title="Continue without 2FA"
          color="outline-secondary"
          size="large"
          className="modal-footer__button"
          onClick={handleContinueWithout2FA}
          disabled={loading}
        />

        <Button
          title="Read more about 2-Factor Authentication"
          color="link"
          size="small"
          className="modal-footer__link"
        />
      </ModalFooter>
    </Modal>
  );
};
